import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.numberOfActiveMembersBy.filtersDirty);
  const showNoDataMessage = useSelector((state) => state.numberOfActiveMembersBy.showNoDataMessage);

  return filtersDirty ? (
    <>
      <button
        className="submit"
        disabled={showNoDataMessage}
        onClick={() => dispatch(actionCreators.updateData())}
      >
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
        Reset
      </button>
    </>
  ) : (
    ""
  );
};
